'use strict';

var React = require('react');

var SvgPrintMajor = function SvgPrintMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 2.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v2.5h1.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-1.5v4a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-4h-1.5a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h1.5v-2.5Zm10 14.5v-5h-8v5h8Zm3-8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3-6h-8v2h8v-2Z"
  }));
};

exports.SvgPrintMajor = SvgPrintMajor;
